import Select from 'components/forms/Select/Select';

export default Select;
